module.exports = __webpack_public_path__ + "img/subscription.170c66c4.svg";